import React from 'react';
import { Button, LabeledInput, AlertNotification } from "@commonsku/styles";
import {oauth} from '../../utils';

const UnDeletePO = () => {
  const [_response, setResponse] = React.useState<string>('');
  const [error, setError] = React.useState<string>('');
  const [success, setSuccess] = React.useState<string>('');

  return <form action="" onSubmit={async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors
    setSuccess(''); // Clear previous success messages
    setResponse(''); // Clear previous response

    try {
      const formData = Object.fromEntries(new FormData(e.currentTarget).entries());
      const response = await oauth('POST', 'tech-support', {
        ...formData,
        actionName: 'undelete_po',
      });

      const data = response.json;
      setResponse(JSON.stringify(data, null, 2));

      if (data.message) {
        setSuccess(data.message);
      } else {
        setSuccess('Purchase order has been successfully undeleted');
      }

    } catch (err) {
      // Handle specific error cases
      if (err.json?.error) {
        setError(err.json.error);
      } else if (err.response?.status === 404) {
        setError('Purchase order not found. Please check the purchase order and try again.');
      } else if (err.response?.status === 403) {
        setError('Access denied. You do not have permission to perform this action.');
      } else if (err.response?.status === 400) {
        setError('Invalid request. Please check your input and try again.');
      } else {
        setError('An error occurred while processing your request. Please try again.');
      }
    }
  }}>
    <LabeledInput
      label="Purchase Order"
      placeholder="Purchase Order"
      name="purchase_order"
      type="text"
      required
    />
    <Button type="submit">Undelete PO</Button>

    {error && (
      <AlertNotification alertType="error" style={{marginTop: '10px'}}>
        {error}
      </AlertNotification>
    )}

    {success && (
      <AlertNotification alertType="success" style={{marginTop: '10px'}}>
        {success}
      </AlertNotification>
    )}

  </form>;
};

UnDeletePO.label = 'Undelete Purchase Order';

export default UnDeletePO;
